import { useEffect, useState } from "react";
import { firestore } from "../firebaseConfig";
import { EnhancedRouteItem } from "../types";
import { useWorkspace } from "../context/WorkspaceContext";
import { mapFirestoreRouteDoc } from "../helpers/routeMappers";

export const useRoute = (orderId: string | undefined) => {
  const [routeData, setRouteData] = useState<EnhancedRouteItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { activeWorkspace } = useWorkspace();

  useEffect(() => {
    if (!orderId || !activeWorkspace?.workspaceId) {
      setRouteData([]);
      return;
    }

    setIsLoading(true);
    setError(null);

    const unsubscribe = firestore
      .collection("routes")
      .where("orderId", "==", orderId)
      .where("workspaceId", "==", activeWorkspace.workspaceId)
      .orderBy("routeDate", "asc")
      .orderBy("routeStopNumber", "asc")
      .onSnapshot(
        (snapshot) => {
          try {
            const routes = snapshot.docs
              .map((doc) => {
                const data = doc.data();
                if (!data) return null;
                return mapFirestoreRouteDoc(doc.id, data);
              })
              .filter((route): route is EnhancedRouteItem => route !== null);

            setRouteData(routes);
          } catch (error) {
            console.error("Error transforming route data:", error);
            setError("Failed to process route data");
            setRouteData([]);
          } finally {
            setIsLoading(false);
          }
        },
        (err) => {
          console.error("Error in route subscription:", err);
          setError("Failed to fetch route data");
          setRouteData([]);
          setIsLoading(false);
        }
      );

    return unsubscribe;
  }, [orderId, activeWorkspace?.workspaceId]);

  return {
    routeData,
    isLoading,
    error,
    refetch: () => {
      // Could implement refetch logic here if needed
    },
  };
}; 
